import { api } from "./axiosInstance";
import type { Plan } from "../types/domain.types";

export async function listPlansRequest(): Promise<Plan[]> {
  const { data } = await api.get<Plan[]>("/plans");
  return data;
}

export interface TileUrlResponse {
  signedUrl: string;
  expiresIn: number;
}

export async function getTileUrlRequest(
  planId: string,
  z: number,
  x: number,
  y: number,
): Promise<TileUrlResponse> {
  const { data } = await api.get<TileUrlResponse>(
    `/plans/${planId}/tile-url`,
    { params: { z, x, y } },
  );
  return data;
}

export interface TileUrlsBatchResponse {
  urls: Array<{ x: number; y: number; signedUrl: string }>;
  expiresIn: number;
}

export async function getTileUrlsBatchRequest(
  planId: string,
  z: number,
  coords: Array<{ x: number; y: number }>,
): Promise<TileUrlsBatchResponse> {
  const { data } = await api.post<TileUrlsBatchResponse>(
    `/plans/${planId}/tile-urls/batch`,
    { z, coords },
  );
  return data;
}
